import feathers from 'feathers';
import hooks from 'feathers-hooks';
import socketio from 'feathers-socketio/client';
import auth from 'feathers-authentication-client';
import io from 'socket.io-client';
import feathersVuex from 'feathers-vuex';
import store from '@/store';

const socket = io(process.env.API_URL, { transports: ['websocket'], timeout: 60000 });

const api = feathers()
  .configure(hooks())
  .configure(socketio(socket))
  .configure(auth({ storage: global.localStorage }))
  .configure(feathersVuex(store, {
    idField: '_id',
    auth: {
      userService: '/users',
    },
  }));

// For every service created, a Vuex store module will be created.
api.service('/users');
api.service('/study');
api.service('/patient');
api.service('/counter');
api.service('/result');
api.service('/mailer');

// Change default timeout for services that hit third party APIs.
api.service('/patient').timeout = 60000;
api.service('/mailer').timeout = 60000;

export default api;



// WEBPACK FOOTER //
// ./src/api/index.js